//import blocks
import { headerBlock } from "./headerBlock";
import { footerBlock } from "./footerBlock";
import { hero_block } from "./hero_block";
import { spacer_block } from "./spacer_block";
import { video_block } from "./video_block";
import { inner_block } from "./inner_block";
import { team_block } from "./team_block";
import { subscribing_block } from "./subscribing_block";
import { image_text_block } from "./image_text_block";
import { patient_questions_block } from "./patient_questions_block";
import { locations_block } from "./locations_block";
import { service_model_block } from "./service_model_block";
import { call_to_action_block } from "./call_to_action_block";
import { treatments_block } from "./treatments_block";
import { resources_slider_block } from "./resources_slider_block";
import { your_specialists_block } from "./your_specialists_block";
import { treatments_speciality_block } from "./treatments_speciality_block";
import { text_block } from "./text_block";
import { related_resources_block } from "./related_resources_block";
import { refer_form_block } from "./refer_form_block";
import { get_in_touch_block } from "./get_in_touch_block";
import { common_symptoms_block } from "./common_symptoms_block";
import { gallery_block } from "./gallery_block";
import { single_hero_block } from "./single_hero_block";
import { book_appointment_block } from "./book_appointment_block";
import { treatments_hero_block } from "./treatments_hero_block";
import { book_appointment_details_block } from "./book_appointment_details_block";
import { faqs_hero_block } from "./faqs_hero_block";
import { appointment_hero_block } from "./appointment_hero_block";
import { patients_hero_block } from "./patients_hero_block";
import { specialists_slider_block } from "./specialists_slider_block";
import { specialists_block } from "./specialists_block";
import { all_specialists_block } from "./all_specialists_block";
import { specialist_details_block } from "./specialist_details_block";
import { specialists_hero_block } from "./specialists_hero_block";
import { featured_post_block } from "./featured_post_block";
import { faqs_block } from "./faqs_block";
import { all_faqs_block } from "./all_faqs_block";
import { treatments_single_hero_block } from "./treatments_single_hero_block";
import { quote_block } from "./quote_block";
import { related_treatments_block } from "./related_treatments_block";
import { treatments_slider_block } from "./treatments_slider_block";
import { why_us_block } from "./why_us_block";
import { treatment_process_block } from "./treatment_process_block";
import { single_text_block } from "./single_text_block";
import { oms_x_perio_block } from "./oms_x_perio_block";
import { treatments_cta_block } from "./treatments_cta_block";
import { specialists_cta_block } from "./specialists_cta_block";
import { faqs_cta_block } from "./faqs_cta_block";
import { about_us_hero_block } from "./about_us_hero_block";
import { location_details_block } from "./location_details_block";
import { image_and_text_block } from "./image_and_text_block";
import { all_resources_block } from "./all_resources_block";
import { patients_child_hero_block } from "./patients_child_hero_block";
import { payment_cards_block } from "./payment_cards_block";
import { payment_block } from "./payment_block";
import { second_cta_block } from "./second_cta_block";
import { event_highlights_block } from "./event_highlights_block";
import { presentations_cards_block } from "./presentations_cards_block";
import { sign_to_watch_block } from "./sign_to_watch_block";
import { landing_hero_block } from "./landing_hero_block";

export function indexBlocks() {
  headerBlock();
  hero_block();
  video_block();
  inner_block();
  footerBlock();
  team_block();
  subscribing_block();
  image_text_block();
  patient_questions_block();
  locations_block();
  service_model_block();
  call_to_action_block();
  treatments_block();
  resources_slider_block();
  treatments_speciality_block();
  your_specialists_block();
  related_resources_block();
  text_block();
  refer_form_block();
  get_in_touch_block();
  common_symptoms_block();
  gallery_block();
  single_hero_block();
  book_appointment_block();
  treatments_hero_block();
  book_appointment_details_block();
  faqs_hero_block();
  appointment_hero_block();
  patients_hero_block();
  specialists_slider_block();
  specialists_block();
  all_specialists_block();
  specialist_details_block();
  specialists_hero_block();
  featured_post_block();
  faqs_block();
  all_faqs_block();
  treatments_single_hero_block();
  quote_block();
  related_treatments_block();
  treatments_slider_block();
  why_us_block();
  treatment_process_block();
  single_text_block();
  oms_x_perio_block();
  treatments_cta_block();
  specialists_cta_block();
  faqs_cta_block();
  about_us_hero_block();
  location_details_block();
  image_and_text_block();
  all_resources_block();
  spacer_block();
  patients_child_hero_block();
  payment_cards_block();
  payment_block();
  second_cta_block();
  event_highlights_block();
  presentations_cards_block();
  sign_to_watch_block();
  landing_hero_block();
}
